import React, { memo, useEffect, useState } from "react";
import { inject, observer } from "mobx-react";
import { useLocation, useNavigate } from "react-router-dom";
import queryString from "query-string";
import SkeletonTable from "../../components/Skeleton/SkeletonTable";
import EmptyData from "../../components/image/EmptyData";
import UnreadText from "../../components/common/UnreadText";
import InfiniteScroll from "react-infinite-scroll-component";
import { Spin, Avatar } from "antd";
import { subStringAvatar } from "../../components/common/CellText";
import { apiUrl } from "../../config";
import { useTheme } from "@mui/material";
import { HiOutlineUser, HiPhone } from "react-icons/hi2";
import { AiOutlineMail, AiOutlineSearch } from "react-icons/ai";

function createData(
  ma_nv,
  username,
  name_lowercase,
  email,
  phone,
  home_phone,
  address,
  position,
  department
) {
  return {
    ma_nv,
    username,
    name_lowercase,
    email,
    phone,
    home_phone,
    address,
    position,
    department,
  };
}

const ListUserContact = (props) => {
  const { userStore } = props;
  const { userList } = userStore;
  const location = useLocation();
  const navigate = useNavigate();
  const queryStringParse = queryString.parse(location.search, {
    arrayFormat: "index",
  });
  const [isRefreshPage, setIsRefreshPage] = useState(true);
  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    keyword: null,
  });
  const [loading, setLoading] = useState(true);
  const theme = useTheme();
  const [rows, setRows] = useState([]);

  const getUserList = async () => {
    try {
      await userStore.getUserList();
    } catch (error) {
      console.log(error);
    } finally {
    }
  };
  useEffect(() => {
    const param = {
      page: queryStringParse.page || filter.page,
      size: queryStringParse.size || filter.size,
      keyword: queryStringParse.keyword || filter.keyword,
    };
    setFilter(param);
    (async () => {
      setLoading(true);
      userStore.clearStore();
      userStore.clearUserListFilter();
      userStore.changeUserListPageIndex(filter.page);
      userStore.changeUserListPageSize(filter.size);
      userStore.changeUserListKeyword(filter.keyword);
      await getUserList();
      setIsRefreshPage(false);
      setLoading(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (isRefreshPage) return;
    const queryStringStringify = queryString.stringify(filter, {
      skipNull: true,
    });
    navigate({
      pathname: "/utility/contacts/users",
      search: queryStringStringify,
    });
    (async () => {
      try {
        setLoading(true);
        userStore.clearStore();
        userStore.clearUserListFilter();
        userStore.changeUserListPageIndex(filter.page);
        userStore.changeUserListPageSize(filter.size);
        userStore.changeUserListKeyword(filter.keyword);
        await getUserList();
        setLoading(false);
      } catch (err) {
        console.log(err);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);
  useEffect(() => {
    setRows(
      userList.map((record) =>
        createData(
          <UnreadText text={record.ma_nv} />,
          <UnreadText
            text={
              <div className="flex gap-2 w-[100%] items-center">
                <HiOutlineUser size={20} color={theme.color.primary} />
                <div
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    width: "100%",
                    color: theme.color.primary,
                  }}
                >
                  {record.username}
                </div>
              </div>
            }
            width={"100%"}
          />,
          <UnreadText
            text={
              <span
                style={{
                  textTransform: "capitalize",
                  fontSize: "16px",
                  color: theme.color.primary,
                }}
              >
                {record.name_lowercase}
              </span>
            }
          />,
          record.email,
          record.phone,
          record.home_phone,
          record.address,
          <UnreadText
            text={
              <div
                style={{
                  whiteSpace: "normal",
                  wordBreak: "break-all",
                  color: theme.color.primary,
                }}
              >
                {record.position?.name}
              </div>
            }
          />,
          <UnreadText
            text={
              <div
                style={{
                  whiteSpace: "normal",
                  wordBreak: "break-all",
                  color: theme.color.primary,
                }}
              >
                {record.department?.name}
              </div>
            }
          />
        )
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userList]);
  const [hasMore, setHasMore] = useState(true);
  const fetchMoreData = async () => {
    if (userList.length >= userStore.userListTotalCount) {
      setHasMore(false);
      return;
    }
    userStore.changeUserListPageIndex(userStore.userListPageIndex + 1);
    try {
      await userStore.getUserList();
    } catch (err) {
      console.log(err);
    }
  };
  const [value, setValue] = useState("");
  const handleQuickSearch = async (event) => {
    event.preventDefault();

    setFilter({
      ...filter,
      page: 0,
      size: 10,
      keyword: value,
    });
    userStore.clearUserOfDepartmentData();
    try {
      userStore.changeUserListKeyword(filter.keyword);
      // await userStore.getUserList();
    } catch (err) {
      console.log(err);
    }
  };
  const handleClickPhone = (phone) => {
    window.location.href = `tel:${phone}`;
  };
  const handleClickEmail = (email) => {
    window.location.href = `mailto:${email}`;
  };

  return (
    <>
      <form onSubmit={(e) => handleQuickSearch(e)}>
        <div
          className="mt-2 px-5 py-3 rounded-xl w-full  focus-visible:outline-none"
          style={{
            display: "flex",
            alignItems: "center",
            background: theme.background.light,
          }}
        >
          <AiOutlineSearch color="#65696e" fontSize={25} />
          <input
            type="text"
            placeholder="Tìm kiếm"
            className="py-1 rounded-xl w-full  focus-visible:outline-none"
            style={{ background: theme.background.light }}
            onChange={(e) => {
              // userStore.clearStore();
              // userStore.clearUserListFilter();
              // setFilter({
              //   ...filter,
              //   page: 0,
              //   size: 10,
              //   keyword: e.target.value.trim(),
              // });
              setValue(e.target.value.trim());
            }}
            // onBlur={(e) => handleQuickSearch(e)}
            // onKeyDown={(e) => {
            //   if (e.key === "Enter") {
            //     handleQuickSearch(e);
            //   }
            // }}
          />
        </div>
      </form>
      {loading ? (
        <SkeletonTable />
      ) : userList?.length > 0 ? (
        <section className="mt-1 overflow-x-auto hideScrollbar pb-[30px]">
          <InfiniteScroll
            dataLength={userList.length}
            next={fetchMoreData}
            hasMore={hasMore}
            style={{
              scrollSnapStop: "always",
            }}
            scrollableTarget="infinityScrollableDiv"
            loader={
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: 10,
                }}
              >
                {userList.length > 10 ? <Spin tip="Đang tải..." /> : ""}
              </div>
            }
          >
            <div className="inline-block w-[100%] overflow-visible hideScrollbar ">
              <div>
                {rows.map((row, index) => (
                  <div
                    key={index}
                    style={{
                      backgroundColor: "#ffffff",
                      padding: "12px 8px 8px 8px",
                      margin: " 15px auto",
                      borderRadius: "10px",
                      boxShadow:
                        "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
                    }}
                  >
                    <div
                      className="flex items-center"
                      style={{
                        fontWeight: "bold",
                        borderBottom: "1px solid #80808070",
                        paddingBottom: 15,
                      }}
                    >
                      <div
                        className="pt-1 "
                        style={{
                          width: "12%",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Avatar
                          size={30}
                          style={{ backgroundColor: "#2C65AC", fontSize: 12 }}
                          src={
                            userList[index]?.imageId &&
                            `${apiUrl}/api/v1/images/${userList[index]?.imageId}`
                          }
                        >
                          {subStringAvatar(userList[index]?.name_uppercase)}
                        </Avatar>
                      </div>
                      <div className="" style={{ width: "88%" }}>
                        <div className="mr-1 w-[100%]">
                          {row.name_lowercase}
                        </div>
                        <div className="flex">
                          <div className="" style={{ minWidth: "100px" }}>
                            <div className="mr-1">Chức vụ:</div>
                          </div>
                          <div className="mr-1">{row.position}</div>
                        </div>
                        <div className="flex">
                          <div className="" style={{ minWidth: "100px" }}>
                            <div className="mr-1">Phòng ban:</div>
                          </div>
                          <div className="mr-1">{row.department}</div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="flex flex-wrap items-center w-full"
                      style={{ margin: 5 }}
                    >
                      <div
                        className="mr-3"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          width: "35%",
                        }}
                        onClick={() => handleClickPhone(row.phone)}
                      >
                        <HiPhone
                          color={theme.color.gray}
                          style={{ marginRight: "5px", flexShrink: 0 }}
                        />
                        {row.phone}
                      </div>
                      <div className="flex  items-center">
                        <AiOutlineMail
                          style={{ marginRight: "5px", flexShrink: 0 }}
                        />
                        <div
                          style={{
                            whiteSpace: "wrap",
                            overflowWrap: "break-word",
                            wordBreak: "break-all",
                          }}
                          onClick={() => handleClickEmail(row.email)}
                        >
                          {row.email}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </InfiniteScroll>
        </section>
      ) : (
        <EmptyData />
      )}
    </>
  );
};

export default memo(inject("userStore")(observer(ListUserContact)));
